import type { Client, ClientContact, PortalAccessEntry } from '~/types/models';

function normalizedEmail(value: unknown): string {
    return String(value || '').trim().toLowerCase();
}

export function resolveClientPortalContact(
    client?: Pick<Client, 'contacts'> | null,
    access?: Pick<PortalAccessEntry, 'contactId' | 'contactName'> | null,
    userEmail?: string | null,
): ClientContact | null {
    const contacts = Array.isArray(client?.contacts) ? client.contacts : [];
    if (contacts.length === 0) return null;

    const contactId = String(access?.contactId || '').trim();
    if (contactId) {
        const matchedById = contacts.find(contact => String(contact.id || '') === contactId);
        if (matchedById) return matchedById;
    }

    const email = normalizedEmail(userEmail);
    if (email) {
        const matchedByEmail = contacts.find(contact => normalizedEmail(contact.email) === email);
        if (matchedByEmail) return matchedByEmail;
    }

    const contactName = String(access?.contactName || '').trim().toLowerCase();
    if (contactName) {
        const matchedByName = contacts.find(contact => String(contact.name || '').trim().toLowerCase() === contactName);
        if (matchedByName) return matchedByName;
    }

    return contacts.find(contact => contact.isPrimary === true) || contacts[0] || null;
}
